import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import type { JSX } from "react";
import { useMutation } from "urql";
import {
    type MissingInformationDeleteMutation,
    type MissingInformationDeleteMutationVariables,
    deleteMutation,
} from "./queries";

interface IProps {
    record: {
        id: number;
        topic: string;
    };
}

function DeleteButton({ record }: IProps): JSX.Element {
    const [deleteResult, executeDelete] = useMutation<
        MissingInformationDeleteMutation,
        MissingInformationDeleteMutationVariables
    >(deleteMutation);

    const doDelete = async () => {
        const result = await executeDelete({ recordId: record.id });
        if (result.error) {
            notifications.show({
                title: "Failed to delete record",
                message: result.error.message,
            });
        } else {
            const deletedRecord = result.data!.missingInformationDelete;
            notifications.show({
                title: "Record deleted",
                message: `Missing information record "${deletedRecord.topic}" deleted`,
            });
        }
    };

    const onClick = () =>
        modals.openConfirmModal({
            title: "Delete Missing Information Record?",
            children: <Text size="sm">Are you sure you want to delete the record for "{record.topic}"?</Text>,
            labels: { confirm: "Confirm", cancel: "Cancel" },
            onConfirm: doDelete,
            confirmProps: { color: "red" },
        });

    return (
        <Button onClick={onClick} disabled={deleteResult.fetching} color="red">
            Delete
        </Button>
    );
}

export default DeleteButton;
